import styled from 'styled-components';

export default styled.div`
  font-size: 12px;
  display: flex;
  align-items: center;

  div {
    display: inline-block;
    margin-right: 4px;
  }

  input {
    appearance: none;
    width: 20px;
    height: 20px;
    border: solid 1px #cccccc;
    margin-right: 8px;
    position: relative;
    outline: none;
    cursor: pointer;
    transition: all 200ms ease-in-out;
    margin-top: 4px;
  }

  input:checked::before {
    content: '';
    width: 14px;
    height: 14px;
    background-color: ${(props) => props.theme.colors.secondary};
    position: absolute;
    top: 2px;
    left: 2px;
  }

  input:disabled::before {
    background-color: ${(props) => props.theme.colors.greyDark};
  }
`;
